import { ManyPolicemanColumnsTypes } from "components/Modals/StepRegister/StepRegisterManyPoliceman/data";
import { IPolicemenValues } from "interfaces/Policeman";
import { IAddress } from "interfaces/Address";
import { IUser } from "interfaces/User";

export type XlsxData = { [key in ManyPolicemanColumnsTypes]: string };

export interface ICreateManyPoliceman {
  policeman: {
    publicAgent: boolean;
    working: boolean;
    region: string;
    patrimonialValues: IPolicemenValues;
    vehicleValues: IPolicemenValues;
  };

  contact: {
    phoneNumber: string;
  };

  user: Partial<IUser>;

  address: Partial<IAddress>;

  banking: {
    accountData: {
      bank?: string;
      account?: string;
      agency?: string;
      pix?: string;
    };
  };
}

class CreateManyPolicemanAdapter {
  adapt(xlsxData: XlsxData[]): any[] {
    return xlsxData.map((xlsxRow) => {
      const baseObject: ICreateManyPoliceman = {
        // contact data
        contact: {
          phoneNumber: String(xlsxRow["contato_do_agente"]).replace(
            /[-.,/#!$%^&*;:{}=\-_`~()]/g,
            ""
          ),
        },

        // user data
        user: {
          type: 3,
          name: xlsxRow["nome_do_agente"],
          email: xlsxRow["email_do_agente"],
          password: xlsxRow["senha_do_agente"],
        },

        // policeman data
        policeman: {
          publicAgent:
            !xlsxRow["agente_publico"] ||
            xlsxRow["agente_publico"].toLowerCase().trim() === "sim",

          working:
            !xlsxRow["agente_esta_trabalhando"] ||
            xlsxRow["agente_esta_trabalhando"].toLowerCase().trim() === "sim",

          region: xlsxRow["regiao_do_agente"],

          patrimonialValues: {
            additionalKm: Number(
              xlsxRow["valor_km_adicional_patrimonial_agente"]
            ),
            additionalHour: Number(
              xlsxRow["valor_hora_adicional_patrimonial_agente"]
            ),
            mileageKm: Number(xlsxRow["valor_franquia_por_km"]),
            exitValue: Number(xlsxRow["valor_saida_patrimonial_agente"]),
          },

          vehicleValues: {
            additionalKm: Number(xlsxRow["valor_km_adicional_veicular_agente"]),
            additionalHour: Number(
              xlsxRow["valor_hora_adicional_veicular_agente"]
            ),
            exitValue: Number(xlsxRow["valor_saida_veicular_agente"]),
            mileageKm: Number(xlsxRow["valor_franquia_por_km"]),
          },
        },

        // address data
        address: {
          street: xlsxRow["rua_do_endereco"].trim(),
          number: String(xlsxRow["numero_do_endereco"]).trim(),
          district: xlsxRow["bairro_do_endereco"].trim(),
          city: xlsxRow["cidade_do_endereco"].trim(),
          uf: xlsxRow["UF_do_endereco"].trim(),
        },

        // banking data
        banking: {
          accountData: {
            bank: String(xlsxRow["dados_bancarios_dados_da_conta_banco"]),
            account: String(xlsxRow["dados_bancarios_dados_da_conta_conta"]),
            agency: String(xlsxRow["dados_bancarios_dados_da_conta_agencia"]),
            pix: String(xlsxRow["dados_bancarios_dados_da_conta_pix"]),
          },
        },
      };

      // appending user data based on document type
      const haveCnpj = xlsxRow["cnpj_do_agente"];

      if (!haveCnpj) {
        baseObject.user.rg = xlsxRow["rg_do_agente"].replace(
          /[-.,/#!$%^&*;:{}=\-_`~()]/g,
          ""
        );
        baseObject.user.cpf = xlsxRow["cpf_do_agente"].replace(
          /[-.,/#!$%^&*;:{}=\-_`~()]/g,
          ""
        );
      } else {
        baseObject.user.cnpj = xlsxRow["cnpj_do_agente"].replace(
          /[-.,/#!$%^&*;:{}=\-_`~()]/g,
          ""
        );
      }

      return baseObject;
    });
  }
}

export const createManyPolicemanAdapter = new CreateManyPolicemanAdapter();
